import NewContentAnalysisForm from './NewContentAnalysisForm.component';

export default NewContentAnalysisForm;
